import React from "react";
import { IconCalendarDown, IconCalendarShare } from "@tabler/icons-react";
import { ActionIcon } from "@mantine/core";
import { Tooltip } from "@mantine/core";
import { Stake } from "../../models/Balances";
import { formatNumber } from "../../utils/formatter";
import { formatCalendarDate } from "../../utils/formatTime";
import styles from "../copyText/CopyText.module.scss";

export default function ExportECSIcon({ data }: { data: Stake }) {
  const SUMMARY_TEXT = "Flare Staking Ends";
  const DESCRIPTION_TEXT = `${formatNumber(data.amount)} FLR staked to \r\n ${data.node_id}`;

  function getCurrentTimestamp() {
    const pad = (n: number) => (n < 10 ? "0" + n : n);
    const now = new Date();
    return `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}T${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}Z`;
  }

  const generateUID = () => {
    const randomNum =
      Math.random().toString(36).substring(2) +
      new Date().getTime().toString(36);
    const sanitizedSummary = SUMMARY_TEXT.replace(/\s/g, "");
    return `${sanitizedSummary}-${randomNum}`;
  };

  const timeStampToICS = (date: Date) => {
    return formatCalendarDate(date);
  };

  const generateContent = (uid: string) => {
    return (
      "BEGIN:VCALENDAR\r\n" +
      "PRODID:-//flare.space//P-chain explorer//EN\r\n" +
      "VERSION:2.0\r\n" +
      "BEGIN:VEVENT\r\n" +
      "SUMMARY:" +
      SUMMARY_TEXT +
      "\r\n" +
      "DTSTART:" +
      timeStampToICS(new Date(data.end_time * 1000)) +
      "\r\n" +
      "DTEND:" +
      timeStampToICS(new Date((data.end_time + 3600) * 1000)) +
      "\r\n" +
      "DTSTAMP:" +
      getCurrentTimestamp() +
      "\r\n" +
      "UID:" +
      uid +
      "\r\n" +
      "DESCRIPTION:" +
      DESCRIPTION_TEXT +
      "\r\n" +
      "LOCATION: \r\n" +
      "STATUS:CONFIRMED\r\n" +
      "PRIORITY:0\r\n" +
      "BEGIN:VALARM\r\n" +
      "TRIGGER:-P1D\r\n" +
      "ACTION:DISPLAY\r\n" +
      "DESCRIPTION:Flare Staking Ends Reminder\r\n" +
      "END:VALARM\r\n" +
      "END:VEVENT\r\n" +
      "END:VCALENDAR"
    );
  };

  const handleClick = () => {
    const uid = generateUID();
    const icsContent = generateContent(uid);

    const blob = new Blob([icsContent], { type: "text/calendar" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "staked_transaction.ics";

    document.body.appendChild(a);
    a.click();
  };
  return (
    <>
      <Tooltip label={"Add to calendar"} withArrow position="right">
        <div id="add-to-calendar">
          <ActionIcon
            c="var(--mid-dark)"
            bg="inherit"
            onClick={handleClick}
            className="calendar-icon"
          >
            <IconCalendarDown size={16} />
          </ActionIcon>
        </div>
      </Tooltip>
    </>
  );
}
